<script>
  import store from "@/store";
  import redirectLogin from '@/helper/redirect';
  export default {
    name: "Login",
    computed: {
      token() {
        return store.getters["auth/token"];
      }
    },
    mounted() {
      this.login(); 
    },
    methods: {
      async firestore() {
        await store.dispatch("auth/firebaseState", false);
        await store.dispatch("auth/firestore_init");
      },
      async login() {
        let token = this.$route.params.short_token;
        await store.dispatch("auth/login", token);

        if (this.token) {
          this.firestore();
          var url = this.$route.query.returnUrl;
          if (url) {
            window.location.href = url;
          } else {
            await this.$router.push({ name: "province" });
          }
        } else { 
          window.location.href = redirectLogin;
        }
      }
    }
  };
</script>